// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tile_wrapper__pjtRS","linked":"tile_linked__Nlmlx","link":"tile_link__I4M0_","blue":"tile_blue__TAUKO","green":"tile_green__Ic7BF","yellow":"tile_yellow__MkMs_"};